export default "__VITE_ASSET__BVgcV2iF__"